import * as types from './types';

export const setModal = payload => ({
  type: types.SET_MODAL,
  payload,
});

export const getModal = payload => ({
  type: types.GET_MODAL,
  payload,
});
